import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=72b8cb97&scoped=true"
import script from "./BankInfo.vue?vue&type=script&lang=ts"
export * from "./BankInfo.vue?vue&type=script&lang=ts"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=72b8cb97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b8cb97",
  null
  
)

export default component.exports